<template>
  <div ref="Radio" id="Radio" class="radio_animate_wrap">
    <img
        class="radio_bg"
        :src="radioBg"
        alt=""
        :style="{width: `${defaultWidth}px`, height: `${defaultHeight}px`}"
    >
    <div class="cpu_position">
      <div
          class="cpu_progress_wrap mirror_x"
          :style="{
          '--cpu_clr': cpuColors[0],
          '--cpu_bg_clr': 'transparent',
          'width': `${cpuWidth}px`,
          'height': `${cpuWidth}px`,
          'background': `conic-gradient(${cpuColors[0]} ${360 * (cpuProgressVal/100)}deg, transparent 0deg)`
    }"
      >
        <img
            class="cpu_bg"
            :src="cpuBg"
            alt=""
            :style="{
          'width': `${cpuWidth - 5.5}px`,
          'height': `${cpuWidth - 5.5}px`,
    }"
        >
        <span
        :style="{
          '--cpu_clr': cpuColors[0],
        '--cpu_bg_clr': 'transparent',
        'width': `${cpuWidth}px`,
        'height': `${cpuWidth}px`,
        'background': `conic-gradient(${cpuColors[0]} ${360 * (cpuProgressVal/100)}deg, transparent 0deg)`
        }"
        ></span>
        <span
            :style="{
          '--cpu_clr': cpuColors[0],
        '--cpu_bg_clr': 'transparent',
        'width': `${cpuWidth}px`,
        'height': `${cpuWidth}px`,
        'background': `conic-gradient(${cpuColors[0]} ${360 * (cpuProgressVal/100)}deg, transparent 0deg)`
        }"
        ></span>
        <span
            :style="{
          '--cpu_clr': cpuColors[0],
        '--cpu_bg_clr': 'transparent',
        'width': `${cpuWidth}px`,
        'height': `${cpuWidth}px`,
        'background': `conic-gradient(${cpuColors[0]} ${360 * (cpuProgressVal/100)}deg, transparent 0deg)`
        }"
        ></span>
      </div>
    </div>
    <div
        class="cpu_wrap"
        :style="{
            '--cpu_clr': cpuColors[0],
            '--cpu_text_clr': '#ffffff'
          }"
    >
      <div class="type_label">{{nowCpuLoad.type_label}}</div>
      <div class="value_label">{{ nowCpuLoad.value_label }}</div>
      <div class="unit_label">{{nowCpuLoad.Unit}}</div>
    </div>
    <div class="gpu_position">
      <div
          class="gpu_progress_wrap mirror_x"
          :style="{
          '--gpu_clr': gpuColors[0],
          '--gpu_bg_clr': 'transparent',
          'width': `${gpuWidth}px`,
          'height': `${gpuWidth}px`,
          'background': `conic-gradient(${gpuColors[0]} ${360 * (gpuProgressVal/100)}deg, transparent 0deg)`
    }"
      >
        <img
            class="gpu_bg"
            :src="gpuBg"
            alt=""
            :style="{
          'width': `${gpuWidth - 5.5}px`,
          'height': `${gpuWidth - 5.5}px`,
    }"
        >
        <span
            :style="{
          '--gpu_clr': gpuColors[0],
        '--gpu_bg_clr': 'transparent',
        'width': `${gpuWidth}px`,
        'height': `${gpuWidth}px`,
        'background': `conic-gradient(${gpuColors[0]} ${360 * (gpuProgressVal/100)}deg, transparent 0deg)`
        }"
        ></span>
        <span
            :style="{
          '--gpu_clr': gpuColors[0],
        '--gpu_bg_clr': 'transparent',
        'width': `${gpuWidth}px`,
        'height': `${gpuWidth}px`,
        'background': `conic-gradient(${gpuColors[0]} ${360 * (gpuProgressVal/100)}deg, transparent 0deg)`
        }"
        ></span>
        <span
            :style="{
          '--gpu_clr': gpuColors[0],
        '--gpu_bg_clr': 'transparent',
        'width': `${gpuWidth}px`,
        'height': `${gpuWidth}px`,
        'background': `conic-gradient(${gpuColors[0]} ${360 * (gpuProgressVal/100)}deg, transparent 0deg)`
        }"
        ></span>
      </div>
    </div>
    <div
        class="gpu_wrap"
        :style="{
            '--gpu_clr': gpuColors[0],
            '--gpu_text_clr': '#ffffff'
          }"
    >
      <div class="type_label">{{nowGpuLoad.type_label}}</div>
      <div class="value_label">{{ nowGpuLoad.value_label }}</div>
      <div class="unit_label">{{nowGpuLoad.Unit}}</div>
    </div>
    <div class="ram_position">
      <div
          class="ram_progress_wrap mirror_x"
          :style="{
          '--ram_clr': ramColors[0],
          '--ram_bg_clr': 'transparent',
          'width': `${ramWidth}px`,
          'height': `${ramWidth}px`,
          'background': `conic-gradient(${ramColors[0]} ${360 * (ramProgressVal/100)}deg, transparent 0deg)`
    }"
      >
        <img
            class="ram_bg"
            :src="ramBg"
            alt=""
            :style="{
          'width': `${ramWidth - 5.5}px`,
          'height': `${ramWidth - 5.5}px`,
    }"
        >
        <span
            :style="{
          '--ram_clr': ramColors[0],
        '--ram_bg_clr': 'transparent',
        'width': `${ramWidth}px`,
        'height': `${gpuWidth}px`,
        'background': `conic-gradient(${ramColors[0]} ${360 * (ramProgressVal/100)}deg, transparent 0deg)`
        }"
        ></span>
        <span
            :style="{
          '--ram_clr': ramColors[0],
        '--ram_bg_clr': 'transparent',
        'width': `${ramWidth}px`,
        'height': `${gpuWidth}px`,
        'background': `conic-gradient(${ramColors[0]} ${360 * (ramProgressVal/100)}deg, transparent 0deg)`
        }"
        ></span>
        <span
            :style="{
          '--ram_clr': ramColors[0],
        '--ram_bg_clr': 'transparent',
        'width': `${ramWidth}px`,
        'height': `${gpuWidth}px`,
        'background': `conic-gradient(${ramColors[0]} ${360 * (ramProgressVal/100)}deg, transparent 0deg)`
        }"
        ></span>
      </div>
    </div>
    <div
        class="ram_wrap"
        :style="{'--ram_text_clr': '#ffffff'}"
    >
      <div
          class="type_label"
          :style="{
            '--ram_type_clr': ramColors[0]
          }"
      >{{nowRam.type_label}}</div>
      <div
          class="value_label"
      >{{ nowRam.value_label }}</div>
      <div
          class="unit_label"
      >{{nowRam.Unit}}</div>
    </div>

    <div class="temp_wrap">
      <div
          class="cpu_temp_wrap"
          :style="{
            '--cpu_temp_clr': cpuColors[0]
          }"
      >
        <span class="title_label">{{nowCpuTemp.type_label}}</span>
        <span class="value_label">{{nowCpuTemp.value_label}}</span>
        <span class="unit_label">{{nowCpuTemp.Unit}}</span>
      </div>
      <div
          class="gpu_temp_wrap"
          :style="{
            '--gpu_temp_clr': gpuColors[0]
          }"
      >
        <span class="title_label">{{nowGpuTemp.type_label}}</span>
        <span class="value_label">{{nowGpuTemp.value_label}}</span>
        <span class="unit_label">{{nowGpuTemp.Unit}}</span>
      </div>
    </div>

    <div
        class="time_wrap"
        :style="{
            '--time_clr': timeColors[0]
          }"
    >
      <div class="unit_label">{{nowDateTimeObj.obj.a}}</div>
      <div class="time_label">{{nowDateTimeObj.obj.time}}</div>
    </div>
  </div>
</template>

<script setup>
import radioBg from '@/assets/Radio/radio_image_bg.png'
import cpuBg from '@/assets/Radio/cpu_bg_b.png'
import gpuBg from '@/assets/Radio/gpu_bg_a.png'
import ramBg from '@/assets/Radio/ram_bg_c.png'
import {onMounted, onUnmounted, reactive, ref, watch} from "vue";
import defaultValue from "@/utils/defaultValue";
import moment from "moment/moment";
import colorTool from "@/utils/colorTool";
const {defaultWidth, defaultHeight} = defaultValue()

const props = defineProps(['sensorValue', 'effectTheme'])
const {changeToRgb} = colorTool()

const cpuProgressEndVal = ref(0) // new Val
const cpuProgressVal = ref(0) // current val
const cpuAnimateTimeTrigger = ref()
const gpuProgressEndVal = ref(0)
const gpuProgressVal = ref(0)
const gpuAnimateTimeTrigger = ref()

const ramProgressEndVal = ref(0)
const ramProgressVal = ref(0)
const ramAnimateTimeTrigger = ref()


const cpuWidth = ref(199)
const gpuWidth = ref(108)
const ramWidth = ref(108)

const cpuColors = ref(['rgb(23, 190, 255)'])
const gpuColors = ref(['rgb(0, 255, 88)'])
const ramColors = ref(['rgb(248, 215, 0)'])
const timeColors = ref(['rgb(255, 255, 255)'])

const nowCpuLoad = reactive({
  type_label: 'CPU',
  value_label: '--',
  Unit: '%'
})

const nowGpuLoad = reactive({
  type_label: 'GPU',
  value_label: '--',
  Unit: '%'
})

const nowRam = reactive({
  type_label: 'RAM',
  value_label: '--',
  Unit: '%'
})

const nowCpuTemp = reactive({
  type_label: 'CPU',
  value_label: '--',
  Unit: '°F'
})
const nowGpuTemp = reactive({
  type_label: 'GPU',
  value_label: '--',
  Unit: '°F'
})

let nowDateTimeObj = reactive({obj: {}})
let timeTiger = ref(null)
const startTime = () => {
  if (timeTiger.value) clearTimeout(timeTiger.value)
  const nowDate = moment().format('HH:mm,a').split(',')
  const timeTextObj = {
    time: nowDate[0], // 時間
    a: nowDate[1].toLocaleUpperCase()
  }
  nowDateTimeObj.obj = timeTextObj
  timeTiger.value = setTimeout(function () {
    startTime()
  }, 150)
}

const handleCpuCircleAnimate = (newVal) => {
  if (cpuAnimateTimeTrigger.value) clearInterval(cpuAnimateTimeTrigger.value)
  const endVal = parseInt(newVal)
  let animateSpeed = 10
  cpuAnimateTimeTrigger.value =  setInterval(function () {
    if (cpuProgressVal.value < endVal) {
      cpuProgressVal.value++
    } else if (cpuProgressVal.value > endVal) {
      cpuProgressVal.value--
    } else clearInterval(cpuAnimateTimeTrigger.value)
  },animateSpeed)
}

const handleGpuCircleAnimate = (newVal) => {
  if (gpuAnimateTimeTrigger.value) clearInterval(gpuAnimateTimeTrigger.value)
  const endVal = parseInt(newVal)
  let animateSpeed = 10
  gpuAnimateTimeTrigger.value =  setInterval(function () {
    if (gpuProgressVal.value < endVal) {
      gpuProgressVal.value++
    } else if (gpuProgressVal.value > endVal) {
      gpuProgressVal.value--
    } else clearInterval(gpuAnimateTimeTrigger.value)
  },animateSpeed)
}

const handleRamCircleAnimate = (newVal) => {
  if (ramAnimateTimeTrigger.value) clearInterval(ramAnimateTimeTrigger.value)
  const endVal = parseInt(newVal)
  let animateSpeed = 10
  ramAnimateTimeTrigger.value =  setInterval(function () {
    if (ramProgressVal.value < endVal) {
      ramProgressVal.value++
    } else if (ramProgressVal.value > endVal) {
      ramProgressVal.value--
    } else clearInterval(ramAnimateTimeTrigger.value)
  },animateSpeed)
}

watch(
    props.sensorValue,
    (n) => {
      if (n) {
        const {
          CPULoad,
          CPUTemperature,
          GPULoad,
          GPUTemperature,
          RAM
        } = n
        if (CPULoad && Object.keys(CPULoad).length > 0) {
          cpuProgressEndVal.value = parseInt(CPULoad.Value) > 0 ? CPULoad.Value : 0
          handleCpuCircleAnimate(cpuProgressEndVal.value)
          Object.assign(nowCpuLoad, CPULoad, {
            value_label: parseInt(CPULoad.Value) > 0 ? CPULoad.Value : '--'
          })
        }
        if (CPUTemperature && Object.keys(CPUTemperature).length > 0) {
          Object.assign(nowCpuTemp, CPUTemperature, {
            value_label: parseInt(CPUTemperature.Value) > 0 ? CPUTemperature.Value : '--'
          })
        }
        if (GPULoad && Object.keys(GPULoad).length > 0) {
          gpuProgressEndVal.value = parseInt(GPULoad.Value) > 0 ? GPULoad.Value : 0
          handleGpuCircleAnimate(gpuProgressEndVal.value)
          Object.assign(nowGpuLoad, GPULoad, {
            value_label: parseInt(GPULoad.Value) > 0 ? GPULoad.Value : '--'
          })
        }
        if (GPUTemperature && Object.keys(GPUTemperature).length > 0) {
          Object.assign(nowGpuTemp, GPUTemperature, {
            value_label: parseInt(GPUTemperature.Value) > 0 ? GPUTemperature.Value : '--'
          })
        }
        if (RAM && Object.keys(RAM).length > 0) {
          ramProgressEndVal.value = parseInt(RAM.Value) > 0 ? RAM.Value : 0
          handleRamCircleAnimate(ramProgressEndVal.value)
          Object.assign(nowRam, RAM, {
            value_label: parseInt(RAM.Value) > 0 ? RAM.Value : '--'
          })
        }
      }
    },
    {immediate: true}
)

watch(props.effectTheme,
    (n) => {
      if (n) {
        const {
          CpuColors,
          GpuColors,
          RamColors,
          TimeColors
        } = n
        cpuColors.value = CpuColors.map(c => changeToRgb(c))
        gpuColors.value = GpuColors.map(c => changeToRgb(c))
        ramColors.value = RamColors.map(c => changeToRgb(c))
        timeColors.value = TimeColors.map(c => changeToRgb(c))
      }
    },
    {immediate: true}
)

onMounted(() => {
  startTime()
})

onUnmounted(() => {
  if (timeTiger.value) clearTimeout(timeTiger.value)
  if (cpuAnimateTimeTrigger) clearInterval(cpuAnimateTimeTrigger.value)
  if (gpuAnimateTimeTrigger) clearInterval(gpuAnimateTimeTrigger.value)
  if (ramAnimateTimeTrigger) clearInterval(ramAnimateTimeTrigger.value)
})
</script>


<style lang="scss">
@import "src/assets/scss/font-family";

.radio_animate_wrap {
  position: relative;
  .mirror_x {
    transform: scaleX(-1);
  }

  .radio_bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  // cpu
  .cpu_position {
    position: absolute;
    top: 101px;
    left: 145px;
    .cpu_progress_wrap {
      position: relative;
      border-radius: 50%;
      animation: animate 0.5s linear infinite;

      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        border-radius: 50%;
        animation: animate 0.5s linear infinite;
        &:nth-child(1) {
          filter: blur(1px);
        }
        &:nth-child(2) {
          filter: blur(2px);
        }
        &:nth-child(3) {
          filter: blur(4px);
        }
      }
    }

    .cpu_bg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;
    }

    .cpu_progress_wrap::after {
      content: '';
      position: absolute;
      inset: 10px;
      border-radius: 50%;
      background: #222;
    }
  }

  .cpu_wrap {
    position: absolute;
    top: 116px;
    left: 164px;
    width: 156px;
    font-family: HyperspaceRace_BoldItalic;
    .type_label {
      font-size: 26px;
      color: var(--cpu_clr);
      text-align: center;
      line-height: 1;
      margin-bottom: -6px;
      text-shadow: 0px 3px 2px #000000;
    }
    .value_label {
      font-size: 103px;
      color: var(--cpu_text_clr);
      text-align: center;
      line-height: 1;
      min-width: 156px;
      text-shadow: 0px 3px 2px #000000;
    }
    .unit_label {
      font-size: 30px;
      color: var(--cpu_text_clr);
      text-align: center;
      line-height: 1;
      margin-top: 6px;
      text-shadow: 0px 3px 2px #000000;
    }
  }

  .gpu_position {
    position: absolute;
    top: 13px;
    left: 355px;
    .gpu_progress_wrap {
      position: relative;
      border-radius: 50%;
      animation: animate 0.5s linear infinite;
      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        border-radius: 50%;
        animation: animate 0.5s linear infinite;
        &:nth-child(1) {
          filter: blur(1px);
        }
        &:nth-child(2) {
          filter: blur(2px);
        }
        &:nth-child(3) {
          filter: blur(4px);
        }
      }
    }
    .gpu_bg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;
    }

    .gpu_progress_wrap::after {
      content: '';
      position: absolute;
      inset: 10px;
      border-radius: 50%;
      background: #222;
    }
  }

  .gpu_wrap {
    position: absolute;
    top: 24px;
    left: 363px;
    width: 90px;
    font-family: HyperspaceRace_BoldItalic;
    .type_label {
      font-size: 19px;
      color: var(--gpu_clr);
      text-align: center;
      line-height: 1;
      margin-bottom: -8px;
      text-shadow: 0px 3px 2px #000000;
    }
    .value_label {
      font-size: 57px;
      color: var(--gpu_text_clr);
      text-align: center;
      line-height: 1;
      min-width: 90px;
      text-shadow: 0px 3px 2px #000000;
    }
    .unit_label {
      font-size: 19px;
      color: var(--gpu_text_clr);
      text-align: center;
      line-height: 1;
      margin-top: 0;
      text-shadow: 0px 3px 2px #000000;
    }
  }

  .ram_position {
    position: absolute;
    top: 360px;
    left: 8px;
    .ram_progress_wrap {
      position: relative;
      border-radius: 50%;
      animation: animate 0.5s linear infinite;
      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        border-radius: 50%;
        animation: animate 0.5s linear infinite;
        &:nth-child(1) {
          filter: blur(1px);
        }
        &:nth-child(2) {
          filter: blur(2px);
        }
        &:nth-child(3) {
          filter: blur(4px);
        }
      }
    }
    .ram_bg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;
    }

    .ram_progress_wrap::after {
      content: '';
      position: absolute;
      inset: 10px;
      border-radius: 50%;
      background: #222;
    }
  }

  .ram_wrap {
    position: absolute;
    top: 372px;
    left: 16px;
    width: 90px;
    font-family: HyperspaceRace_BoldItalic;
    .type_label {
      font-size: 19px;
      color: var(--ram_type_clr);
      text-align: center;
      line-height: 1;
      margin-bottom: -8px;
      text-shadow: 0px 3px 2px #000000;
    }
    .value_label {
      font-size: 54px;
      color: var(--ram_text_clr);
      text-align: center;
      line-height: 1;
      min-width: 90px;
      text-shadow: 0px 3px 2px #000000;
    }
    .unit_label {
      font-size: 19px;
      color: var(--ram_text_clr);
      text-align: center;
      line-height: 1;
      margin-top: 0;
      text-shadow: 0px 3px 2px #000000;
    }
  }

  .temp_wrap {
    position: absolute;
    display: inline-block;
    top: 368px;
    left: 125px;
    font-family: HyperspaceRace_BoldItalic;
    width: 180px;
    .cpu_temp_wrap {
      color: var(--cpu_temp_clr);
      margin-bottom: 10px;
    }
    .gpu_temp_wrap {
      color: var(--gpu_temp_clr);
    }
    .cpu_temp_wrap, .gpu_temp_wrap {
      font-size: 30px;
      line-height: 1;
      text-shadow: 0px 0px 6px #000000;
      .title_label {
        display: inline-block;
        width: 62px;
      }
      .value_label {
        display: inline-block;
        width: 64px;
        text-align: center;
      }
      .unit_label {}
    }
  }

  .time_wrap {
    position: absolute;
    top: 377px;
    left: 350px;
    font-family: HyperspaceRace_BoldItalic;
    color: var(--time_clr);
    width: 100px;
    text-align: left;
    letter-spacing: 1px;
    .unit_label {
      font-size: 20px;
      line-height: 1;
      text-shadow: 0px 0px 6px #000000;
    }
    .time_label {
      font-size: 38px;
      line-height: 1;
      text-shadow: 0px 0px 6px #000000;
    }
  }
}
</style>
